import { AnnualTradingReportFilter } from "../types";
import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

export const getAnnualExcel = (
  user: User,
  filter: AnnualTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getannualtradingxls",
    params: {
      userid: user.userId,
    },
  });
};

export default getAnnualExcel;
